import {
  createStyles,
  Theme,
  WithStyles,
} from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      minWidth: 296,
      maxWidth: 496,
      padding: 32,
      display: "flex",
      flexDirection: "column",
      rowGap: 24,
    },
    title: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
    },
    description: {
      ...theme.fonts.p1,
      color: theme.colors.textDefault,
      whiteSpace: "pre-line",
    },
    buttonsContainer: {
      marginTop: 8, // 24 + 8
      display: "flex",
      flexDirection: "row",
      columnGap: 8,
      justifyContent: "space-between",
    },
    childrenContainer: {
      marginTop: 8,
    },
    buttonGap: {
      marginRight: "7px",
      borderRadius: 0,
    },
    modalHeader: {
      width: "100%",
    },
    modalBody: {
      width: "100%",
    },
    modalFooter: {
      width: "100%",
    },
    stickyHeader: {
      position: "relative",
      overflow: "hidden",
      "& $modalHeader": {
        position: "absolute",
        width: "calc(100% - 64px)",
        left: "32px",
        top: "32px",
      },
      "& $modalBody": {
        overflow: "auto",
        maxHeight: "100%",
        marginTop: "40px",
        paddingRight: "10px",
        paddingLeft: "10px",
        "&::-webkit-scrollbar": {
          width: "6px",
          height: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: theme.colors.background,
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: theme.colors.textSubtle,
          borderRadius: "4px",
        },
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
